import { useEffect } from 'react';

/**
 * Automatically clears a value after the provided delay. Intended for
 * ephemeral UI messaging such as error alerts and warnings that should
 * disappear after a short time.
 */
export function useAutoDismiss<T>(value: T, onDismiss: () => void, delay = 4000): void {
  useEffect(() => {
    if (!value) {
      return;
    }

    const timer = window.setTimeout(onDismiss, delay);
    return () => window.clearTimeout(timer);
  }, [value, onDismiss, delay]);
}
